/**
 * The first `max` UTF-16 code units of `text`, one fewer when the cut would
 * split a surrogate pair (an emoji): a lone surrogate is not valid JSON text
 * for ant's parser, which then refuses the whole request.
 */
export function sliceWhole(text: string, max: number): string {
  if (text.length <= max) return text;
  const last = text.charCodeAt(max - 1);
  const splitsPair = last >= 0xd800 && last <= 0xdbff;
  return text.slice(0, splitsPair ? max - 1 : max);
}
